
import { Vue, Component, Prop, Watch} from "vue-property-decorator";
import { cloneDeep } from "lodash";

import FormGroup from "@/components/form/FormGroup.vue";
import Checkbox from "@/components/form/Checkbox.vue";
import ProjectCriteriaMultiselect from "@/components/scheduler/schedulerSelects/ProjectCriteriaMultiselect.vue";
import ProjectStatusSelect from "@/components/scheduler/schedulerSelects/ProjectStatusSelect.vue";
import ProfileCountrySelect from "@/components/autocompleteMultiselects/ProfileCountrySelect.vue";
import ProjectCityMultiselect from "@/components/autocompleteMultiselects/ProjectCityMultiselect.vue";
import RegionInput from "@/components/autocompleteMultiselects/RegionInput.vue";
import ProjectsMultiselect from "@/components/autocompleteMultiselects/ProjectsMultiselect.vue";

import { Project } from "@/generated/graphql";
import Roles from "@/entities/Roles";
import { getEmptyFiltersResultMessage, getEmptyListMessage } from "@/helpers/lists/emptyListMessages";
import ProjectAdditionalFilters from "@/entities/scheduler/additionalFiltersInterfaces/ProjectAdditionalFilters";
import projectViewFiltersTemplate from "@/data/filtersTemplates/scheduler/projectViewFiltersTemplate";
import DateRange from "@/entities/scheduler/DateRange";
import moment from "moment";
import FormDateRangePicker from "@/components/form/FormDateRangePicker.vue";
import UiButton from "@/components/button/ui-button.vue"

@Component({
  components: {
    FormGroup,
    Checkbox,
    ProjectCriteriaMultiselect,
    ProjectStatusSelect,
    ProjectsMultiselect,
    ProjectCityMultiselect,
    RegionInput,
    ProfileCountrySelect,
    FormDateRangePicker,
    UiButton
  },
})
export default class ProjectViewAdditionalFIlters extends Vue {
  @Prop({ type: String, required: true }) readonly currentUserRole!: Roles;
  @Prop({ type: Boolean, default: false }) readonly shouldClearFilters!: boolean;

  projects: Project[] = [];
  filterFields: ProjectAdditionalFilters = cloneDeep(projectViewFiltersTemplate);
  showProjects: boolean = false;
  selectedProjectsIds: string[] = [];
//wip 3
  rangeStart: Date = new Date();
  rangeEnd: Date = moment(this.rangeStart).add(1, 'M').toDate();
//wip 3 end 
  showActivitiesCheckbox = {
    name: "Show Tasks",
    id: "showActivities",
    selected: false,
  }
//wip 3.1 end

  created(): void {
    this.$emit("appliedFiltersNumberChanged", this.numberOfAppliedFilters);
  }

  @Watch("shouldClearFilters")
  handleClearFilters(value: boolean): void {
    if (value === true) {
      this.clearFilters();
      this.$emit("filtersReset");
    }
  }

  @Watch("propToWatch")
  handlePropToWatchChange(): void {
    this.$emit("filtersChanged", {
      countries: this.countriesNames,
      states: this.statesNames,
      cities: this.citiesNames,
      criteria: this.filterFields.criteria,
      status: this.filterFields.status,
    })
  }

  @Watch("numberOfAppliedFilters", { immediate: true })
  appliedFiltersChanged() {
    this.$emit("appliedFiltersNumberChanged", this.numberOfAppliedFilters);
  }

  @Watch("showActivities")
  showActivitiesToggle(): void {
    this.$emit("showActivitiesToggle", this.showActivities)
  }

  @Watch("dateRange")
  handleDateRange() {
    this.$emit("rangeStart", this.rangeStart)
    this.$emit("rangeEnd", this.rangeEnd)
  }

  get numberOfAppliedFilters(): any {
    const appliedFiltersQuantity = {
      countries: this.filterFields.countries.length ? 1 : 0,
      states: this.filterFields.states.length ? 1 : 0,
      cities: this.filterFields.cities.length ? 1 : 0,
      criteria: this.filterFields.criteria.length ? 1 : 0,
      status: this.filterFields.status.length && this.filterFields.status[0].id !== "All" ? 1 : 0,
    }

    return Object.values(appliedFiltersQuantity)
      .reduce((prevValue, curValue) => {
        return prevValue + curValue;
      }, 0);
  }

  get loading(): boolean {
    return this.$apollo.queries.projects.loading && !this.projects.length
  }

  get customPlaceholderMessage(): string {
    if (this.numberOfAppliedFilters && !this.projects.length) {
      return getEmptyFiltersResultMessage("projects");
    }
    return getEmptyListMessage("projects");
  }

  get dateRange(): DateRange {
    return {
      startDate: this.rangeStart,
      endDate: this.rangeEnd,
    }
  }

  get countriesNames(): string[] {
    return this.filterFields.countries.map((country) => country.name);
  }

  get statesNames(): string[] {
    return this.filterFields.states.map((state) => state.name);
  }

  get citiesNames(): string[] {
    return this.filterFields.cities.map((city) => city.name);
  }

  get propToWatch(): string {
    return JSON.stringify([
      this.filterFields.countries,
      this.filterFields.states,
      this.filterFields.cities,
      this.filterFields.criteria,
      this.filterFields.status,
    ]);
  }

  get isManager(): boolean {
    return this.currentUserRole === Roles.MANAGER;
  }

  get showActivities(): boolean {
    return this.showActivitiesCheckbox.selected;
  }
//wip 4
  handleDateRangeChange(date: DateRange) {
    this.rangeStart = date.startDate;
    this.rangeEnd = date.endDate;
  }
// wip 4 end 

  clearFilters(): void {
    this.filterFields = cloneDeep(projectViewFiltersTemplate);
  }

  closeModal(): void{
    this.$emit('close')
  }
}
